import { en } from './en.js'
import { novelJa } from './novel-ja.js'
import { novelComparisonJa } from './novel-comparison.js'
import { novelShellJa, withNovelShell } from './novel-shell.js'

export const ja = structuredClone(en)

ja.visualGameAdmin.conversionFunnelDevices = {'label': 'アクセス元のデバイス', 'all': 'すべて', 'desktop': 'パソコン', 'mobile': 'スマートフォン', 'tablet': 'タブレット'}

ja.visualGameAdmin.pageFunnel = {'button': 'ページファネル', 'title': 'ページファネル', 'home': 'ホーム', 'auth': 'ログイン・登録入口', 'game': 'ゲームページ', 'note': '選択期間・デバイスで順番に各段階に到達したセッション数。ログインにはPCのログイン・登録ダイアログを含みます。過去の未記録データは集計できません。', 'loading': '読み込み中…', 'error': '読み込み失敗', 'sessions': 'セッション'}

ja.visualGameAdmin.pageFunnel.viewUsers = 'ユーザーを見る'
ja.visualGameAdmin.pageFunnel.peopleUnit = '人'
ja.visualGameAdmin.pageFunnel.timesUnit = '回'

ja.visualGameAdmin.pageFunnel.userFilter_all = 'ファネル：登録・ログイン'

ja.visualGameAdmin.pageFunnel.userFilter_sign_up = 'ファネル：期間内の登録ユーザー'

ja.visualGameAdmin.pageFunnel.userFilter_login = 'ファネル：期間内のログインユーザー'

ja.visualGameAdmin.usageActivity = {
  "title": "サイト利用 · 行動明細",
  "button": "明細を見る",
  "all": "すべての行動",
  "search": "ユーザー、ゲーム、記録 ID を検索",
  "user": "ユーザー",
  "game": "ゲーム",
  "kind": "行動",
  "status": "状態",
  "time": "日時",
  "detail": "記録を見る",
  "empty": "該当する記録はありません",
  "loading": "読み込み中…",
  "error": "読み込み失敗",
  "note": "入力記録は独自イベントに基づくため GA4 と異なる場合があります。未記録の入力内容やプレイ ID は推測しません。",
  "limit": "最新 1000 件を表示。期間を絞ると他の記録を確認できます。",
  "text_input": "文字入力",
  "voice_input": "音声入力",
  "slice_video": "シーン動画生成",
  "global_video": "全体動画生成",
  "free_game": "無料ゲーム生成"
}

Object.assign(ja.visualGameAdmin.usageActivity, {
  "status_queued": "待機中",
  "status_running": "生成中",
  "status_ready": "完了",
  "status_failed": "失敗",
  "status_submitting": "送信中",
  "status_submitted": "送信済み",
  "status_ok": "成功",
  "status_error": "失敗",
  "status_generating": "生成中",
  "status_generation_failed": "生成失敗",
  "status_pending_review": "審査待ち",
  "status_review_rejected": "却下",
  "status_published": "公開済み",
  "status_archived": "アーカイブ済み"
})

ja.visualGameAdmin.usageActivity.records = '件'

ja.visualGameAdmin.paypointActivity = {
  "title": "課金ポイント · 発生明細",
  "all": "すべて",
  "game": "ページ",
  "kind": "課金場面",
  "status": "発生理由",
  "note": "独自イベントは GA4 と異なる場合があります。動画ダイアログの表示はポイント不足を意味しません。過去の記録には必要ポイント、残高、プレイ ID がありません。",
  "billing_paypoint_gameplay": "プレイ",
  "billing_paypoint_ending_video": "エンディング動画",
  "billing_paypoint_story_video": "ストーリー動画",
  "status_insufficient_balance": "プレイのポイント不足",
  "status_dialog_open": "生成ダイアログ表示"
}

ja.visualGameAdmin.paypointActivity.search = 'ユーザー、ページ、記録 ID を検索'

ja.visualGameAdmin.orderDrilldown = {
  "button": "注文を見る",
  "dateField": "日時の基準",
  "created_at": "作成日時",
  "paid_at": "支払日時"
}

Object.assign(ja.visualGameAdmin.orderDrilldown, {
  "since": "開始日時",
  "until": "終了日時"
})

ja.visualGameAdmin.orderDrilldown.updated_at = 'ステータス更新日時'

ja.visualGameAdmin.trafficBaseline = {
  "confirmed": "確認済み増分",
  "first": "初回取得再生数（過去基準なし）",
  "missing": "基準値不足・増分は不完全",
  "note": "選択期間内に公開された動画はゼロを基準とし、初回取得再生数も増加分に含めます。期間前に公開された動画や公開日不明の動画で期間前の記録がない場合、初回取得分は別表示します。取得日は公開日ではありません。",
  "observed": "初回観測日",
  "filter": "基準値不足",
  "unchanged": "増加なし（基準値あり）",
  "later": "初回観測後の増加"
}

ja.visualGameAdmin.funnelAuth = {
  registration: 'サイト登録',
  login: 'サイトログイン',
  new_users: '新規ユーザーのログイン',
  existing_users: '既存ユーザーのログイン',
  note: '新規ユーザーは選択期間内の登録、既存ユーザーは期間開始前の登録です。登録成功後の自動ログインを含みます。人数は重複を除き、回数は自動ログインとその後の成功ログインを含みます。登録とログインは重複するため合算しません。',
  user_type: 'ユーザー種別',
  registered_at: '登録日時',
  new_type: '新規ユーザー',
  existing_type: '既存ユーザー',
  auto_login: '登録後の自動ログイン'
}

ja.visualGameAdmin.funnelPeriods = {
  yesterday: '昨日',
  last_three_days: '直近3日間'
}

ja.visualGameAdmin.videoExport = {
  button: '現在の一覧をCSV出力',
  published_sort: '公開日時順',
  published_label: '公開日時',
  unknown: '未記録'
}

withNovelShell(ja.visualGameAdmin, novelShellJa)
Object.assign(ja.visualGameAdmin, novelJa, { novelComparison: novelComparisonJa })

ja.visualGameAdmin.storyFilmPromptReview = {
      title: 'ショートドラマ プロンプト審査',
      subtitle: 'ショットごとの最終プロンプトとリクエストパラメータの内容審査。内容承認は H3 呼び出しでも再生可能な完成品でもありません。',
      gateNotice: '承認はプロンプトと計画内容のみ。ベンダー H3 呼び出しは別の予算/上限ゲートの下にあり、現在は未承認で実行ボタンはありません。',
      loading: '読み込み中…',
      empty: 'リクエストパックなし',
      filters: {
      status: '審査状態',
      all: 'すべて',
      owner: 'プレイヤー（owner）',
      ownerPlaceholder: 'user id',
      run: 'セーブ run',
      runPlaceholder: 'run_id',
      branch: 'ブランチ',
      branchPlaceholder: 'branch_id',
      season: 'シーズン',
      seasonPlaceholder: 'season_id',
      episode: 'エピソード',
      episodePlaceholder: 'episode_id',
      planDigest: '計画バージョン',
      planDigestPlaceholder: 'plan_digest',
      version: 'パック版',
      versionPlaceholder: 'バージョン番号',
    },
      actions: {
      search: '検索',
      clear: '条件をクリア',
      view: '表示',
      more: 'さらに読み込む',
      approve: '内容を承認',
      reject: '修正へ戻す',
      rejectPlaceholder: '戻す理由（必須）',
      regenerate: '新しい版を生成',
      simulatedNotification: '模擬通知を見る',
    },
      validation: {
      limit: '{count}/{max} 文字（前後の空白を除く）',
      required: '差し戻す理由を入力してください。',
      too_long: '理由は最大 {max} 文字です。短くしてから送信してください。差し戻しは行われていません。',
      invalid_body: '理由が受け付けられませんでした。入力を確認してください：{message}',
    },
      notice: {
      approve: '内容を承認しました。H3 未呼び出し・課金なし。',
      reject: '理由を記録して戻しました。',
      regenerate: '新しい版を生成しました。再審査が必要です。',
    },
      columns: {
      episode: 'エピソード',
      version: '版',
      status: '状態',
      shots: 'ショット',
      duration: '尺',
      digest: 'パック摘要',
      createdAt: '作成日時',
    },
      status: {
      draft: '審査待ち',
      in_review: '審査中',
      approved: '承認済み',
      rejected: '修正へ戻し',
      superseded: '新版に置換',
    },
      detail: {
      title: 'パック #{id} · v{version}',
      owner: 'プレイヤー',
      film: '作品',
      season: 'シーズン',
      episode: 'エピソード',
      run: 'run',
      branch: 'ブランチ',
      range: 'ターン範囲',
      sourceVersion: 'ソース版',
      snapshot: 'スナップショット',
      planDigest: '計画摘要',
      packDigest: 'パック摘要',
      planVersion: 'パック/計画版',
      cutPolicy: 'カット方針版',
      costModel: 'コストモデル版',
      gate: 'ゲート',
      gateValue: '予算={budget} · コストモデル={cost} · 予測ポイント={points} · ネガティブ対応={negative}',
      provider: 'ベンダー',
      providerValue: '{provider} / {model} · {size} · steps={steps} · turbo={turbo} · キュー={priority} · {shots} ショット',
      shotsTitle: 'ショット別リクエストパック',
      chars: '{count} 文字',
      sendable: '送信可',
      notSendable: '送信不可',
      blocked: '未準備の理由',
      promptTitle: '最終ポジティブプロンプト',
      requestTitle: 'リクエストパラメータ（確認済み項目のみ）',
      evidenceTitle: 'ソース証拠（プレイヤー可視）',
      anchorsTitle: '人物/場所アンカー',
      speakers: '人物',
      locations: '場所',
      references: '参照素材',
      negativeTitle: 'ネガティブプロンプト（内容審査用・ベンダー項目未確認）',
      negativeGate: 'ネガティブプロンプトは送信 request に含めません。現行 H3 アダプターはこの項目を確認していません。',
      episodeSummary: 'ショット {shots} · 尺 {duration}ms · 総フレーム {frames} · フレーム量子化 {frameMs}ms · 上限合計 {caps}ms',
      quoteSummary: '見積スナップショット：{status} · 予測ポイント {points} · 係数 {ppm}ppm · {currency}',
      cost: '予測コスト：{points}',
      costUnapproved: '未承認',
    },
      events: {
      title: '審査履歴',
    },
    }

ja.visualGameAdmin.storyFilmPromptReview.simulatedPage = {
      title: '模擬通知プレビュー',
      subtitle: '固定の模擬ペイロードによる通知審査。DB 読み書き・メール・課金はありません。',
      isolation: '本ページは実際の ready outbox・メディア・初回無料 consumed・SMTP から完全に分離され、実再生や返金はありません。',
      back: 'プロンプト審査へ戻る',
    }
ja.visualGameAdmin.storyFilmPromptReview.detail.trim = '計画 {plan}ms / 生成 {gen}ms（超過分をトリム）'

ja.visualGameAdmin.storyFilmPromptReview.detail.providerValue = '{provider} / {model} · {size} · {aspect} · モバイル {fit} · 能力 {capability} · steps={steps} · turbo={turbo} · キュー={priority} · {shots} ショット'

ja.visualGameAdmin.storyFilmPromptReview.detail.episodeSummary = 'ショット {shots} · 計画尺 {duration}ms · 計画フレーム {frames} · 量子化 {frameMs}ms · 上限合計 {caps}ms · H3 {h3fps}fps'
ja.visualGameAdmin.storyFilmPromptReview.detail.selection = 'A 選段契約'

ja.visualGameAdmin.storyFilmPromptReview.detail.selectionValue = '{status} · {version} · {units} 単位 · 未使用 {omitted} 字 · {digest}'
ja.visualGameAdmin.storyFilmPromptReview.detail.selectionArc = '結末証拠 settlement={settlement} · ending={ending} · opening={opening} · climax={climax} · resolution={resolution}'
ja.visualGameAdmin.storyFilmPromptReview.detail.generation = '完成尺 {final}ms / 生成 {gen}ms / cap {cap}ms'

ja.visualGameAdmin.storyFilmPromptReview.detail.capExceeded = '生成が cap を {over}ms 超過、送信不可'

ja.visualGameAdmin.storyFilmPromptReview.detail.durationSplit = '完成 {final}ms / 生成 {gen}ms / cap {cap}ms / 超過 {exceeded} 鏡'
